import React, { Component } from 'react'
 class UstoMagasine extends React.Component{
    render(){
        return(
            <div>
                <p>UstoMagasine</p>
            </div>
        );
    }
 }

 export default UstoMagasine;